// Unlocked fork: PostHog analytics / phone-home is permanently disabled.
export default defineNuxtPlugin(() => {})
